import thunkMiddleware from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import { batchStoreEnhancer, batchMiddleware } from 'redux-batch-enhancer';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import createRavenMiddleware from 'raven-for-redux';

import { getConfig } from 'modules/config';

export const getBaseMiddlewares = () => [
  batchMiddleware,
  apiMiddleware(fetch),
  thunkMiddleware.withExtraArgument((state) => getConfig(state)),
  routerMiddleware(browserHistory),
];

export const getDevOnlyMiddlewares = () => {
  if (__DEV__) {
    return [
      require('redux-validate-fsa')(),
      require('redux-immutable-state-invariant').default(),
      require('redux-logger').createLogger({ collapsed: true }),
    ];
  }
};

const Raven = require('raven-js');

export const getProductionOnlyMiddlewares = () => [
  createRavenMiddleware(Raven),
];

export const getBaseStoreEnhancers = () => [batchStoreEnhancer];

export const getDevOnlyStoreEnhancers = () => {
  if (__DEV__) {
    // By default we try to read the key from ?debug_session=<key> in the address bar
    const getDebugSessionKey = function () {
      const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
      return matches && matches.length ? matches[1] : null;
    };

    return [
      // Lets you write ?debug_session=<key> in address bar to persist debug sessions
      require('redux-devtools').persistState(getDebugSessionKey()),
    ];
  }
};

export const getProductionOnlyStoreEnhancers = () => [];



// WEBPACK FOOTER //
// ./src/client/store/reduxConfig/index.js